// extracted by mini-css-extract-plugin
export default {"main":"InitialLoader_main__pZfKd","wrapper":"InitialLoader_wrapper__++CoA"};